"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.user.list': '用户',
    'route.user.create': '添加用户',
    'route.user.edit': '编辑用户',
};
